import React from "react";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Logo from "./Logo";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { Chip } from "@material-ui/core";
import KeyboardCoverOverlay from "./KeyboardCoverOverlay";
import {
  StyledHeaderActions,
  ModelSelectionBox,
  StyledModelCard,
  StyledActionArrow,
  StyledDivider,
} from "./common.styles";
import models from "./models";

const SubModelSelection = ({ match: { params } }) => {
  const currentModel = params.model || "";

  if (!models[currentModel].submodels) {
    return <Typography>Ups, this model does not exists</Typography>;
  }

  const { submodels } = models[currentModel];

  return (
    <>
      <StyledHeaderActions>
        <Box flex="1" />
        <a href="https://www.knightscope.com/demo">
          <Chip onClick={() => {}} label="Request a demo" color="secondary" />
        </a>
      </StyledHeaderActions>
      <ModelSelectionBox>
        <Box>
          <Link to={`/`}>
            <Box display="flex" alignItems="center" ml={-0.5}>
              <ChevronLeftIcon color="primary" fontSize="large" />
              <Typography
                variant="caption"
                color="primary"
                style={{ textTransform: "uppercase", fontWeight: "800" }}
              >
                Back
              </Typography>
            </Box>
          </Link>
          <Hidden smDown>
            <Typography variant="h2">Select Model</Typography>
          </Hidden>
          <Hidden smUp>
            <Box display="flex" pl={1} pr={1} alignItems="center">
              <Typography variant="h4">Select Model</Typography>
              <Box className="show-more" display="flex" alignItems="center">
                <Typography variant="caption">Scroll to see more</Typography>
                <Box mr={0.5} />
                <ArrowRightAltIcon color="disabled" />
              </Box>
            </Box>
          </Hidden>
          <Box mt={1} flex="0" />
          <Box display="flex" flexDirection="row" width="100%">
            {Object.keys(submodels).map((model, index) => (
              <Box
                mr={index < Object.keys(submodels).length ? 1.65 : 0}
                pr={index === Object.keys(submodels).length - 1 ? 1 : 0}
                boxSizing="border-box"
              >
                <Link to={`/creator/${currentModel}/${model}`}>
                  <StyledModelCard display="flex">
                    <StyledActionArrow>
                      <Box flex="1" />
                      <ArrowRightAltIcon color="primary" fontSize="large" />
                    </StyledActionArrow>
                    <img src={submodels[model].promo} />
                    <Box
                      flexDirection="column"
                      justifyContent="center"
                      height="100%"
                      pr={2}
                    >
                      <Typography variant="h3">
                        {submodels[model].specs.speed
                          ? `${submodels[model].specs.speed} mph`
                          : "Stationary"}
                      </Typography>
                      <Typography variant="caption">Maximum Speed</Typography>
                      <Box mb={1} />
                      <Typography variant="h3">
                        {submodels[model].specs.terrain}
                      </Typography>
                      <Typography variant="caption">
                        Terrain Capability
                      </Typography>
                      <Box mb={1} />
                      <Typography variant="h3">
                        {submodels[model].specs.weight} lbs.
                      </Typography>
                      <Typography variant="caption">Weight</Typography>
                      <Box mb={1} />
                      <Typography variant="h3">
                        {submodels[model].specs.dimensions}
                      </Typography>
                      <Typography variant="caption">
                        Dimensions (W × H × L)
                      </Typography>
                      {submodels[model].descriptionPromo ? (
                        <StyledDivider />
                      ) : null}
                      <Typography variant="caption" mb={5}>
                        {submodels[model].descriptionPromo}
                      </Typography>
                    </Box>
                  </StyledModelCard>
                </Link>
                <Box mt={1} />
                <Typography variant="h4">{submodels[model].name}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </ModelSelectionBox>
      <KeyboardCoverOverlay />
    </>
  );
};

export default SubModelSelection;
